<template>
  <b-row>
    <b-col tag="main" lg="12" xl="9" class="mb-4">
      <div class="bg-white shadow-sm position-relative p-4 mb-3">
        <Header :team-id="teamId" />
        <b-row class="mt-5">
          <b-col sm="6" md="6" lg="4" class="mb-2">
            <b-select :value="teamId" @change="onSelectTeam">
              <b-select-option v-for="team in teams" :key="team.id" :value="team.id">
                {{team.name}}
              </b-select-option>
            </b-select>
          </b-col>
          <b-col sm="6" md="6" lg="4" class="mb-2">
            <b-select :value="timespan" @change="onChangeTimespan">
              <b-select-option
                v-for="option in timespans"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled">
                {{option.text}}
              </b-select-option>
            </b-select>
          </b-col>
        </b-row>
      </div>
      <most-encourage :data="mostEncouragingData" class="mb-3" />
      <card-collapsible class="card-plain rounded-0 mb-3">
        <template #header>
          <b>Team members key metrics - Individual kudos</b>
        </template>
        <key-metrics
          :loading="isLoadingKeyMetrics"
          :profiles="profiles"
          :data="teamKeyMetrics"
        />
      </card-collapsible>

      <card-collapsible class="card-plain rounded-0 mb-3">
        <template #header>
          <b>Team work standards</b>
        </template>
        <work-standards :loading="isLoadingWorkStandards" :data="workStandardsData" />
      </card-collapsible>

      <card-collapsible class="card-plain rounded-0 mb-3">
        <template #header>
          <b>Team expertise - kudos received at the individual and team level for skills</b>
        </template>
        <expertise :loading="isExpertiseDataLoading" :data="expertiseData" />
      </card-collapsible>
    </b-col>
    <b-col lg="12" xl="3">
      <b-row>
        <b-col tag="aside" lg="6" xl="12" class="mb-4">

        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { Header, KeyMetrics, MostEncourage, WorkStandards, Expertise } from '@/components/Dashboard'
import CardCollapsible from '@/components/common/CardCollapsible'
import { timespans } from '@/helpers/dashboard'

export default {
  name: 'TeamPerformance',

  computed: {
    ...mapGetters([
      'teams',
      'profiles',
      'keyMetrics',
      'isLoadingKeyMetrics',
      'expertise',
      'isLoadingExpertise',
      'isKudosLoading',
      'kudos',
      'workStandards',
      'isLoadingWorkStandards',
      'mostEncouraging',
      'isLoadingMostEncouraging'
    ]),

    teamId() {
      return Number(this.$route.params.teamId)
    },

    timespans() {
      return timespans()
    },

    teamKeyMetrics() {
      return this.isLoadingKeyMetrics ? [] : this.keyMetrics(this.teamId)
    },

    isExpertiseDataLoading() {
      return this.isKudosLoading || this.isLoadingExpertise
    },

    expertiseData() {
      return this.isLoadingExpertise ? [] : (this.expertise(this.teamId) || []).map(p => ({
        value: p.count,
        label: (this.kudos[p.kudo] || {}).name
      }))
    },

    workStandardsData() {
      return this.isLoadingWorkStandards ? [] : (this.workStandards(this.teamId) || []).map(p => ({
        value: p.count,
        label: p.name
      }))
    },

    mostEncouragingData() {
      return this.isLoadingMostEncouraging ? {} : this.mostEncouraging(this.teamId)
    }
  },

  watch: {
    teamId() {
      this.load()
    }
  },

  data() {
    return {
      timespan: 'month'
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      const params = { teamId: this.teamId, timespan: this.timespan }
      this.$store.dispatch('fetchTeamMetrics', params)
      this.$store.dispatch('fetchTeamExpertise', params)
      this.$store.dispatch('fetchTeamWorkStandards', params)
      this.$store.dispatch('fetchTeamMostEncouraging', params)
      this.$store.dispatch('fetchKudosIfNot')
    },

    onSelectTeam(teamId) {
      this.$router.push({ name: this.$route.name, params: { teamId } })
    },

    onChangeTimespan() {
    }
  },

  components: {
    Header,
    CardCollapsible,
    KeyMetrics,
    MostEncourage,
    WorkStandards,
    Expertise
  }
}
</script>
